module.exports = __webpack_public_path__ + "static/media/test.a1332505.png";